import { Subject, from, Observable, throwError } from 'rxjs'
import { Container, IInit } from '../container/Container'

type Status = {
  variant: 'success' | 'error' | 'warning'
  message?: string // e.message()
  error?: Error
}

export interface IStatusService extends IInit {
  sendStatus(sts: Status): void

  statusObservable(): Observable<any>
}

export class StatusService implements IStatusService {
  private readonly _status: Subject<Status>

  constructor() {
    this._status = new Subject<Status>()
  }

  init(c: Container): void {}

  sendStatus(sts: Status): void {
    this._status.next(sts)
  }

  statusObservable(): Observable<Status> {
    return this._status.pipe()
  }
}
